<style lang="sass" scoped>
.tickets-input
  display: flex
  justify-content: space-around
.code-input
  display: flex
  justify-content: space-evenly
.ticket-group
  display: flex
.validation-message
  display: flex
  justify-content: space-around
.valid-ticket
  color: green
.invalid-ticket
  color: red
</style>

<template lang="pug">
div.data-section
  h3 INGRESSOS
  div.my-2.tickets-input
    div
      v-text-field(v-model='start' min=0 label='Início')
    div
      v-text-field(v-model='end' label='Fim')
    v-btn(@click='searchTicketRange()') Buscar
  div.text-center(v-if='loading_range')
    v-progress-circular(indeterminate)
  div.my-2(v-if='!loading_range && ticket_types.length > 0')
    div(v-for='(ticket_type, i) in ticket_types' :key='i')
      div.ticket-group
        div.pa-4 <b>TIPO:</b> {{ticket_type.name}}
        div.pa-4 <b>QUANTIDADE:</b> {{ticket_type.tickets.length}}
      v-divider(v-if='i < ticket_types.length - 1')
  h4 TESTAR VALIDADE DO INGRESSO
  div.my-2.code-input
    div
      v-text-field(v-model='code' label='Código')
    div
    v-btn(@click='testTicket()') Testar
  div.text-center(v-if='loading_test')
    v-progress-circular(indeterminate)
  div.validation-message.my-2(v-if='!loading_test && validation != null')
    div.my-2(v-if='validation == true')
      div.valid-ticket.pa-4 Ingresso {{code}} válido!
    div.my-2(v-if='validation == false')
      div.invalid-ticket.pa-4 Ingresso {{code}} inválido. Motivo: {{error_message}}
  h4 ZERAR TODAS AS ENTRADAS
  v-btn(@click='resetPopup()') Zerar
  v-dialog(v-model='reset_popup_open' width='600px')
    v-card
      v-card-title
        | Tem certeza de que quer zerar todas as entradas?
      v-card-actions
        v-btn(@click='resetEntries()') Sim, zerar
</template>

<script>
import utils from '../../utils/requests'

export default {
  props: {
    id: String
  },
  data () {
    return {
      ticket_types: [],
      loading_range: false,
      start: 0,
      end: 0,
      loading_test: false,
      validation: null,
      error_message: '',
      reset_popup_open: false
    }
  },
  mounted () {
  },
  methods: {
    searchTicketRange () {
      this.loading_range = true
      const data = {
        event_id: this.id,
        start: this.start,
        end: this.end
      }
      utils.postAPI('/tickets/search_ticket_range', data).then(res => {
        console.log(res)
        this.ticket_types = res.ticket_types
        this.loading_range = false
      })
    },
    testTicket () {
      this.loading_test = true
      const data = {
        code: this.code,
        event_id: this.id,
        orders: [],
        validator: ''
      }
      utils.postAPI('/tickets/test_ticket_validation', data).then(res => {
        console.log(res)
        this.validation = res.validation
        this.error_message = res.error
        this.loading_test = false
      })
    },
    resetPopup () {
      this.reset_popup_open = true
    },
    resetEntries () {
      console.log('Zerando todas as entradas do evento')
      const data = {
        id: this.id
      }
      utils.postAPI('/event/delete_all_event_entries', data).then(res => {
        console.log(res)
        this.validation = res.validation
        this.error_message = res.error
        this.reset_popup_open = false
      })
    }
  }
}
</script>
